import React, { useEffect, useState } from "react";
import "./Login.css";
import { auth, checkAuth, getProjects } from "../../services";
import { useNavigate } from "react-router-dom";

export const Login = () => {
    const [loginInput, setLoginInput] = useState("");
    const [error, setError] = useState("");
    const navigate = useNavigate()

    const handleSubmit = async () => {
        const { data, error } = await auth({ code: loginInput });

        if (data?.message === "Authentication successful") {
            window.localStorage.setItem("judge_id", data.judge_id)
            window.localStorage.setItem("judge_code", loginInput)
            navigate("/voting")
            setError(""); // Clear error on success
        } else {
            setError(error || "Invalid code"); // Handle error properly
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleSubmit();
        }
    };

    useEffect(() => {
        (async () => {
            const auth = await checkAuth()
            if (auth.log) {
                navigate("/voting/1")
                return
            }
        })()
    }, [])

    return (
        <div className="login">
            <div className="login_block">
                <input
                    type="text"
                    placeholder="Judge code"
                    value={loginInput}
                    onChange={(e) => setLoginInput(e.target.value)}
                    onKeyDown={handleKeyDown} // Listen for Enter key press
                />
                <button className="confirm" onClick={handleSubmit}>Log In</button>
                {error && <p className="error">{error}</p>}
            </div>
        </div>
    );
};
